import _get from "lodash/get";
import styled, { css } from 'styled-components';
import { rem, transparentize } from 'polished';
import horizontalScrollTheme from '../styles/horizontalScrollTheme';
var ScrollButton = styled.button.withConfig({
  displayName: "ScrollButton",
  componentId: "sc-1wtjyxv-0"
})(["background-color:", ";border:0;cursor:pointer;height:", ";position:absolute;top:0;z-index:3;&:focus{outline:0;}", " ", " ", " ", ""], function (_ref) {
  var btnColor = _ref.btnColor;
  return btnColor || 'transparent';
}, function (_ref2) {
  var theme = _ref2.theme;
  return "calc(\n                    100% -\n                        " + rem(_get(theme, 'horizontalScroll.scrollbar.height', horizontalScrollTheme.horizontalScroll.scrollbar.height)) + "\n                )";
}, function (_ref3) {
  var btnWidth = _ref3.btnWidth;
  return btnWidth && css(["width:", ";"], rem(btnWidth));
}, function (_ref4) {
  var showEnd = _ref4.showEnd,
      showStart = _ref4.showStart,
      btnColor = _ref4.btnColor,
      theme = _ref4.theme;
  return (showEnd || showStart) && css(["&:after{background-image:linear-gradient( to left,", " 10%,", " 100% );content:'';height:", ";pointer-events:none;position:absolute;top:0;width:", ";}"], btnColor, transparentize(100, btnColor), "calc(\n                    100% -\n                        " + rem(_get(theme, 'horizontalScroll.scrollbar.height', horizontalScrollTheme.horizontalScroll.scrollbar.height)) + "\n                )", rem(24));
}, function (_ref5) {
  var showEnd = _ref5.showEnd;
  return showEnd && css(["right:0;&:after{left:-", ";}"], rem(24));
}, function (_ref6) {
  var showStart = _ref6.showStart;
  return showStart && css(["left:0;&:after{right:-", ";transform:scaleX(-1);}"], rem(24));
});
export default ScrollButton;